<template>
  <form v-if="!created" @submit.prevent="submitForm" class="space-y-4 bg-white dark:bg-gray-900 p-6 rounded-lg shadow">
    <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">Nová adresa</h2>

    <div>
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Název firmy / Jméno</label>
      <input v-model="form.company" type="text" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" placeholder="Např. Moje s.r.o." />
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Ulice</label>
        <input v-model="form.street" type="text" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Město</label>
        <input v-model="form.city" type="text" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">PSČ</label>
        <input v-model="form.zip" type="text" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Země</label>
        <input v-model="form.country" type="text" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" placeholder="CZ" />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 border-t border-gray-200 dark:border-gray-700 pt-4 mt-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">IČO</label>
        <input v-model="form.ico" type="text" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" />
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">DIČ</label>
        <input v-model="form.dic" type="text" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white" />
      </div>
    </div>

    <div class="pt-2">
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">Vlastní metadata (JSON)</label>
      <textarea v-model="customRaw" rows="2" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-800 dark:text-white text-xs font-mono" placeholder='{ "priorita": "vysoká" }'></textarea>
    </div>

    <div class="pt-4">
      <button
          type="submit"
          :disabled="loading"
          class="w-full md:w-auto px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 disabled:opacity-50 transition-colors"
      >
        {{ loading ? 'Vytvářím...' : 'Vytvořit adresu' }}
      </button>
    </div>
  </form>

  <div v-else class="p-6 text-center bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
    <p class="text-green-800 dark:text-green-300 font-medium">Adresa byla úspěšně vytvořena!</p>
    <button @click="resetForm" class="mt-4 text-sm text-blue-600 dark:text-blue-400 hover:underline">Vytvořit další</button>
  </div>
</template>

<script lang="ts">
import { AddressCreationRequest } from '@haxo-cz/orders-ts-client';
import { useAppStore } from '@/stores/appStore';

export default {
  name: 'CreateAddressForm',
  data() {
    return {
      appStore: useAppStore(),
      loading: false,
      created: false,
      customRaw: '',
      form: {
        street: '',
        city: '',
        zip: '',
        country: 'CZ',
        company: '',
        ico: '',
        dic: '',
        custom: {}
      } as AddressCreationRequest
    };
  },
  methods: {
    async submitForm() {
      this.loading = true;
      try {
        // Zpracování custom JSONu
        if (this.customRaw.trim()) {
          this.form.custom = JSON.parse(this.customRaw);
        } else {
          this.form.custom = {};
        }

        await this.$addressesApi.createAddress(
            this.appStore.selectedProject.spaceId,
            this.appStore.selectedProject._id,
            this.form
        );

        this.created = true;
        // Pokud používáš toto v modalu, můžeš zde emitovat událost pro refresh seznamu
        this.$emit('created');
      } catch (error: any) {
        console.error(error);
        alert('Chyba při vytváření adresy. Zkontrolujte formát JSON nebo povinná pole.');
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.created = false;
      this.form = {
        street: '',
        city: '',
        zip: '',
        country: 'CZ',
        company: '',
        ico: '',
        dic: '',
        custom: {}
      };
      this.customRaw = '';
    }
  }
};
</script>